import { FC, PropsWithChildren } from "react";
import useFeatureFlag from "web/hooks/useFeatureFlag";

interface FeatureFlagProps {
    name: string;
}

const FeatureFlag: FC<PropsWithChildren<FeatureFlagProps>> = ({children, name}) => {
    const hasFeature = useFeatureFlag(name);
    return hasFeature ? <>{children}</> : null;
}

export default FeatureFlag;